<template>
  <div>
    <div class="wrapper">
    <nav v-if="this.showAdministration" id="sidebar" :class="{active: this.menuClose}">
      <NavbarAdmin @dismissClick="dismissClicked" />
    </nav>
    <div id="content" :class="{active: this.menuClose}">
      <Navbar @menuClick="menuClicked" />
      <router-view />
    </div>
    </div>
  </div>
</template>

<script>
// https://itnext.io/anyway-heres-how-to-create-a-multiple-layout-system-with-vue-and-vue-router-b379baa91a05
import Navbar from '@/components/Navbar.vue'
import NavbarAdmin from '@/components/NavbarAdmin.vue'

export default {
  name: 'default-layout',
  data () {
    return {
      menuClose: false
    }
  },
  components: {
    Navbar, NavbarAdmin
  },
  methods: {
    menuClicked () {
      console.log('menu clicked')
      this.menuClose = !this.menuClose
    },
    dismissClicked () {
      this.menuClose = !this.menuClose
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    showAdministration () {
      return this.$store.getters.isOwner || this.$store.getters.isAdmin
    }
  }
}
</script>

<style>
.wrapper {
    display: flex;
    /* width: 100%; */
    align-items: stretch;
}

.overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: rgba(0,0,0,0.5);
    text-align: center;
    /* transition: all 0.5s ease-in-out; */
}
.overlay span {
    padding: 5px;
    font-size: 2.0em;
    border-radius: 5px;
    color: #fff;
    position:relative;
    top:50%;
}

/* SPINNER START */
.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 55px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* SPINNER END */

#content {
    width: 100%;
    min-height: 100vh;
    transition: all 0.3s;
    top: 0;
    right: 0;
}
 /* end new */

a[data-toggle="collapse"] {
    position: relative;
}

/* .dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
} */

@media (max-width: 768px) {
    #sidebar {
        margin-left: -250px;
        position: fixed;
    }
    #sidebar.active {
        margin-left: 0;
        height: 100vh;
    }
    #content {
      position: absolute;
    }
    #dismiss {
      visibility: visible;
    }
}
</style>
